module.exports = __webpack_public_path__ + "assets/fonts/AdelleSans-Regular.otf";